<template>
    <div class="d-flex align-items-center position-relative p-1" :class="selectedClass">
        <div v-for="child in component.value" @click="onComponentClick(child)" :class="elementClasses(child)"
             :style="componentStyle(child)">
            <label-renderer v-if="child.type === 'Label'" :component="child" :layout="layout"></label-renderer>
            <header-renderer v-if="child.type === 'Header'" :component="child" :layout="layout"></header-renderer>

            <link-renderer v-if="child.type === 'Link'" :component="child" :layout="layout"></link-renderer>
            <icon-renderer v-if="child.type === 'Icon'" :component="child" :layout="layout"></icon-renderer>
            <image-renderer v-if="child.type === 'Image'" :component="child"></image-renderer>
            <button-renderer v-if="child.type === 'Button'" :component="child" :execute-click="executeClick" :layout="layout"></button-renderer>
        </div>

        <div v-if="!executeClick" id="rowComponentContextMenu" class="dropdown position-absolute" :class="[displayClass]" style="top: 0px; right: -40px;">
            <i class="fas fa-caret-down dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            </i>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <a class="dropdown-item" href="javascript:void(0)" @click="onAddButtonClick">Add Button</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="onAddIconClick">Add Icon</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="onAddLabelClick">Add Label</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="onAddLinkClick">Add Link</a>
            </div>
        </div>

    </div>
</template>

<script>
    import LabelRenderer from "./LabelRenderer.vue";
    import HeaderRenderer from "./HeaderRenderer.vue";
    import LinkRenderer from "./LinkRenderer.vue";
    import IconRenderer from "./IconRenderer.vue";
    import ImageRenderer from "./ImageRenderer.vue";
    import ButtonRenderer from "./ButtonRenderer.vue";
    import PageFactory from "../../utils/PageFactory";

    export default {
        name: 'RowComponentRenderer',
        components: {ButtonRenderer, ImageRenderer, IconRenderer, LinkRenderer, HeaderRenderer, LabelRenderer},
        props: ['component', 'layout', 'executeClick'],
        data () {
            return {
                model: webase.model,
                factory: new PageFactory()
            }
        },
        computed: {
            selectedClass() {
                return webase.utils.component.isChildComponent(this.component, this.layout.selectedComponent) ? 'row-container-border' : ''
            },
            displayClass() {
                return webase.utils.component.isChildComponent(this.component, this.layout.selectedComponent) ? 'd-flex' : 'd-none'
            },
        },
        mounted () {
            console.log('RowComponentRenderer mounted')
            console.log(this.component)
        },
        methods: {
            onComponentClick(childComponent) {
                webase.utils.layout.deselectComponents(this.layout)
                childComponent.selected = true
                this.layout.selectedComponent = childComponent

                //$('#componentContextMenu').dropdown('dispose')
                // $('#rowComponentContextMenu').dropdown('dispose')
            },

            onAddButtonClick() {
                let button = this.factory.createButton('New Button')
                this.component.value.push(button)
                this.$forceUpdate()
            },

            onAddLabelClick() {
                let label = this.factory.createHtmlComponent('Label', 'New Label')
                this.component.value.push(label)
                this.$forceUpdate()
            },

            onAddLinkClick() {
                let link = this.factory.createLink('New Link')
                this.component.value.push(link)
                this.$forceUpdate()
            },

            onAddIconClick() {
                let icon = {
                    icon: "check-circle",
                    style: "far",
                    type: "fa"
                }

                let iconComponent = this.factory.createIconComponent(icon)
                this.component.value.push(iconComponent)
                iconComponent.selected = true
                this.layout.selectedComponent = iconComponent
                this.$forceUpdate()
                webase.eventDispatcher.emit('editIconClick')
            },

            elementClasses(childComponent) {
                return this.marginClass(childComponent) + ' ' + this.paddingClass(childComponent) + ' ' + this.borderClasses(childComponent)
            },
            marginClass(childComponent) {
                if(!childComponent.margin) {
                    return ''
                }

                return webase.utils.ui.getMarginClass(childComponent.margin)
            },
            paddingClass(childComponent) {
                if(!childComponent.padding) {
                    return ''
                }

                return webase.utils.ui.getPaddingClass(childComponent.padding)
            },
            borderClasses(childComponent) {
                let borderCssClasses = ''

                if(this.hasBorder(childComponent)) {
                    borderCssClasses = " border "
                }

                if(this.hasBorder(childComponent) && !this.isCustomBorderColor(childComponent)) {
                    borderCssClasses += (" border-" + childComponent.border.color)
                }

                return borderCssClasses
            },
            hasBorder(childComponent) {
                return childComponent.border && childComponent.border.type && childComponent.border.type !== 'none'
            },

            isCustomBorderColor(childComponent) {
                return childComponent.border && childComponent.border.color && childComponent.border.color.indexOf('#') === 0
            },

            componentStyle(childComponent) {
                return {
                    ...this.colorBorderStyle(childComponent),
                    ...this.borderRadiusStyle(childComponent),
                    ...this.borderWidthStyle(childComponent)
                }
            },

            colorBorderStyle(childComponent) {
                return this.isCustomBorderColor(childComponent) ? { borderColor: childComponent.border.color + '  !important'} : {}
            },

            borderRadiusStyle(childComponent) {
                return this.hasBorderRadius(childComponent) ? { borderRadius: childComponent.border.cornerRadius + 'px' } : {}
            },

            borderWidthStyle(childComponent) {
                return this.hasBorderWidth(childComponent) ? { borderWidth: childComponent.border.width + 'px !important' } : {}
            },

            hasBorderRadius(childComponent) {
                return childComponent.border && childComponent.border.type !== 'none' && childComponent.border.cornerRadius
            },

            hasBorderWidth(childComponent) {
                return childComponent.border && childComponent.border.type !== 'none' && childComponent.border.width
            }
        }
    }
</script>

<style>
    .row-container-border {
        border: 2px dashed #dee2e6;
    }
</style>
